import { FC, Fragment } from "react";
import { useStyles } from "../../useStyles";
import DownloadIcon from "../../assets/images/download_icon.svg";
import { Colors } from "../../styles";
import { IconButton, Link } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";

const useFormStyles = makeStyles(() =>
    createStyles({
        icon: {
            width: 24,
            height: 24,
            objectFit: "contain",
        },
        downloadLink: {
            color: Colors.mellowYellow,
            cursor: "pointer",
            fontSize: "22px",
            "& > span": {
                color: Colors.mellowYellow,
            },
        },
        iconButton: {
            marginLeft: "-12px",
        },
    }),
);

export const AdjustableLoadDataSheetDownloadForm: FC = () => {
    const classes = useStyles();
    const formClasses = useFormStyles();

    return (
        <Fragment>
            <p className={classes.p}>
                Laden Sie bitte das Datenblatt Wärmepumpe und Gerät zur Raumkühlung herunter und
                erfassen Sie Ihre Daten. Idealerweise unterstützt Sie hierbei Ihr
                Elektrofachbetrieb. Im nächsten Schritt „Dokumente“ laden Sie das Datenblatt bitte
                hoch.
            </p>
            <Link
                className={formClasses.downloadLink}
                href={`${process.env.PUBLIC_URL}/Datenblatt_Waermepumpe_Geraet_zur_Raumkuehlung_2023_12.pdf`}
                target="_blank"
            >
                <IconButton className={formClasses.iconButton} aria-hidden>
                    <img alt="Download" className={formClasses.icon} src={DownloadIcon} />
                </IconButton>
                <span className={classes.p}>Datenblatt Wärmepumpe und Gerät zur Raumkühlung</span>
            </Link>
        </Fragment>
    );
};
